import {IKeyValue, IAdjustmentFee, IHasAdjustmentFees} from '../../interfaces';

const Locale = 'en-US';

export class ReportExtensions {
    private static getSafeNumber(value: number) {
        if (value === null || typeof value === 'undefined') {
            return 0;
        }

        return value;
    }

    static getValueByKey<T1, T2>(items: IKeyValue<T1, T2>[], key: T1): T2 {
        if (!items || items.length === 0) {
            return null;
        }

        return items.find(item => item.key === key)?.value;
    }

    static getAdjustmentList(item: IHasAdjustmentFees): IAdjustmentFee[] {
        const adjustments: IAdjustmentFee[] = [];
        const adjustmentFees = item.adjustmentFees;
        const keys = Object.keys(adjustmentFees);

        for (const index in keys) {
            if (adjustmentFees.hasOwnProperty(keys[index])) {
                const net = +adjustmentFees[keys[index]];

                if (net !== 0) {
                    adjustments.push({
                        category: keys[index],
                        net
                    });
                }
            }
        }

        return adjustments;
    }

    static isNegative(value: number): boolean {
        if (!value) {
            return false;
        }

        return value < 0;
    }

    static toIntegerString(value: number, formatNegative = true): string {
        return ReportExtensions.toDecimalString(value, 0, 0, formatNegative);
    }

    static toDecimalString(
        value: number,
        maximumFractionDigits = 2,
        minimumFractionDigits = maximumFractionDigits,
        formatNegative = true,
        removeFractionIfInteger = false): string {
        let amount = ReportExtensions.getSafeNumber(value);
        if(removeFractionIfInteger && Number.isInteger(amount)){
            maximumFractionDigits = 0;
            minimumFractionDigits = 0;
        }
        const isNegative = amount < 0;

        if (formatNegative && isNegative) {
            amount = Math.abs(amount);
        }

        if (maximumFractionDigits < minimumFractionDigits) {
            minimumFractionDigits = maximumFractionDigits;
        }

        const result = amount.toLocaleString(Locale, {
            maximumFractionDigits,
            minimumFractionDigits,
        });

        if (formatNegative && isNegative) {
            return `(${result})`;
        }

        return result;
    }
}
